import { EmailContact } from "@/Common/Api/Contacts/Dto/EmailContact";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

interface IEmailContactProps {
    value: string;
    onChange: (value: string) => void;
}

function EmailContactForm(props: IEmailContactProps): JSX.Element {
    const { getText } = useTranslation();
    const { value, onChange } = props;

    const validationHelper = new ValidationHelper();

    return (
        <div className="form-group margin-md-bottom">
            <label htmlFor="contactValue">
                <strong>{getText("EmailLabel")}</strong>
            </label>

            <TextboxMaskedControl
                isEmail
                returnMaskedValue
                id="contactValue"
                className="width-60-percent"
                isValid={EmailContact.validateEmail(value)}
                value={value}
                mask={validationHelper.getEmailValidationRule()?.EditMaskPattern ?? ""}
                onChangeFunction={onChange}
                validationErrorMessage={validationHelper.getEmailValidationRule()?.ValidationErrorMessageLookupId
                    ? cacheStore.GetLocalizedValueByLookupId(validationHelper.getEmailValidationRule()?.ValidationErrorMessageLookupId)
                    : ""
                }
            />
        </div>
    );
}

export { EmailContactForm };
